import React from 'react';
import { Row, Col } from 'react-bootstrap';
import '../../../assets/style/WelcomeVideos.css';
import { ColSizeType, VideoPreviewType } from '../../../utils/Types';
import VideoPreview from '../../../components/VideoPreview';

interface VideosPreviewProps {
  videos: VideoPreviewType[];
  handleRemove: (id: number | string) => void;
  cancelWithBg?: boolean;
  colSize?: ColSizeType;
}

const VideosPreview: React.FC<VideosPreviewProps> = ({
  videos,
  handleRemove,
  cancelWithBg,
  colSize,
}) => {
  return (
    <div className="uploaded-files-container">
      {videos.length > 0 && (
        <Row>
          {videos.map((video) => (
            <Col
              lg={colSize?.lg ?? 4}
              md={colSize?.md ?? 6}
              sm={colSize?.sm ?? 6}
              xs={colSize?.xs ?? 12}
              key={video?.id}
              className="pt-1"
            >
              <VideoPreview
                video={video}
                handleRemove={handleRemove}
                cancelWithBg={cancelWithBg}
              />
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};

export default VideosPreview;
